import React, { useEffect, useState } from "react";
import { algoliaPlantEnumsRelevance } from "./algoliaSearch";
import { TextField, InputAdornment } from "@mui/material";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { primaryColorTextField } from "../theme/globalStyles";

import "./Search.css";

function PlantEnumsSearchInput({saveToList, page, setLoading}: any) {
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
      algoliaPlantEnumsRelevance
        .search(searchValue, {
          hitsPerPage: 100,
          page: page,
          clickAnalytics: true,
        })
        .then(({ hits }: any) => {
          setSearchResults(hits);
          setLoading(false);
        })
        .catch((err: any) => {
          console.error("Algolia search error:", err);
          setError("Sökningen misslyckades. Kontrollera Algolia-konfigurationen.");
          setLoading(false);
        });
  }, [searchValue, page, setLoading]);

  useEffect(() => {
    if (searchResults.length > 0) {
      saveToList(searchResults);
    }
  }, [searchResults, saveToList]);

  return (
    <>
      <TextField
        id="search"
        label="Search"
        variant="outlined"
        value={searchValue}
        sx={primaryColorTextField}
        fullWidth
        size="small"
        onChange={(e) => setSearchValue(e.target.value)}
        error={!!error}
        helperText={error}
        InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon
                        style={{ color: '#44a99a'}}
                      />
                    </InputAdornment>
                  ),
                  endAdornment: searchValue !== "" && (
                    <InputAdornment position="end">
                      <CloseOutlinedIcon
                        style={{
                          color: "#44a99a",
                          cursor: "pointer",
                        }}
                        onClick={() => setSearchValue("")}
                      />
                    </InputAdornment>
                  ),
                }}
      />
    </>
  );
}

export default PlantEnumsSearchInput;
